<template>
    <Dialog header="Confirm Cancel!" v-model:visible="Editmodel"
        :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }" :style="{ width: '30vw' }" :modal="true"
        :closable="false">
        <p>{{ content }}</p>
        <template #footer>
            <AddButton :btnname="btnnameyes" @click="$emit('yes')" />
            <AddButton :btnname="btnnameno" @click="$emit('no')" />
        </template>
    </Dialog>
</template>
<script lang="ts">

import { defineComponent, ref } from 'vue'
export default defineComponent({

    props: {

        Editmodel: {
            readonly: false,
            type: Boolean,
            default: ref(false),
        },

        content: {
            type: String,
            default: ""
        },

        HeaderName: {
            type: String,
            default: ""
        },
        btnnameyes: {
            type: String,
            default: "Yes"
        },
        btnnameno: {
            type: String,
            default: "No"
        }
    },

    setup() {

        return {
        }
    },


    methods: {

    }
})

</script>